/* 订单详情 */
<template>
  <div id="orderUpdate"  class="q-pa-md">
    <PageHeader content="订单详情" />
    <el-row class="rightBtn">
      <el-button  type="primary" @click="toPlan">查看计划</el-button>
      <el-button  type="danger" @click="toUpdateOrder" :disabled="!disabled">修改订单</el-button>
    </el-row>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12">
          <CustSelector ref="custSelector" />
        </el-col>
        <el-col :span="12">
          <el-form-item label="加工工厂">
            <el-select v-model="form.supplierId" placeholder="请选择类型" style="width: 100%;" clearable :disabled="disabled">
              <el-option v-for="item in supplierList" :key="item.id" :label="item.supplierName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="订单编号">
            <el-input v-model="form.orderNo" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户订单号">
            <el-input v-model="form.customerOrderNo" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <YarnSelector ref="yarnSelector"/>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类型">
            <el-select
              v-model="form.roundType"
              placeholder="请选择类型"
              style="width: 100%;"
              :disabled="disabled"
              clearable
            >
              <el-option label="筒纱" value="筒纱"></el-option>
              <el-option label="绞纱" value="绞纱"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="是否购销">
            <el-select
              v-model="form.delivery"
              placeholder="请选择是否购销"
              style="width: 100%;"
              :disabled="disabled"
            >
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否并线">
            <el-select
              v-model="form.combine"
              placeholder="请选择是否并线"
              style="width: 100%;"
              :disabled="disabled"
            >
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="订单日期">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.orderDate"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
              :disabled="disabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期望交期">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.deliveryDate"
              value-format="yyyy-MM-dd"
              style="width: 100%;"
              :disabled="disabled"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="订单价格">
            <el-input v-model="form.orderPrice" :disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单状态">
            <el-select
              v-model="form.orderStatus"
              placeholder="请选择订单状态"
              style="width: 100%;"
              :disabled="disabled"
            >
              <el-option label="待加工" value="0"></el-option>
              <el-option label="部分加工完成" value="1"></el-option>
              <el-option label="全部加工完成" value="2"></el-option>
              <el-option label="部分已开票" value="3"></el-option>
              <el-option label="全部已开票" value="4"></el-option>
              <el-option label="订单完成" value="5"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="照片附件">
            <Upload ref="upload" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="订单明细">
        <OrderItemTable ref="orderItemTable" />
      </el-form-item>

      <el-form-item label="客户备注">
        <el-input
          type="textarea"
          v-model="form.customerRemark"
          :autosize="{ minRows: 4, maxRows: 10}"
          :disabled="disabled"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="recover" v-show="!disabled">恢复</el-button>
        <el-button type="primary" @click="updateOrder" v-show="!disabled">修改</el-button>
        <el-button @click="cancel" v-show="!disabled">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>


<script>
import PageHeader from "../components/PageHeader.vue";
import OrderItemTable from "../components/OrderItemTable.vue";
import CustSelector from "../components/CustSelector.vue";
import Upload from "../components/Upload.vue";
import YarnSelector from "@/components/YarnSelector.vue";
import { list } from "@/api/erp/supplier"
export default {
  components: {
    PageHeader,
    OrderItemTable,
    CustSelector,
    Upload,
    YarnSelector
  },
  data() {
    return {
      form: {},
      supplierList:[],
      pictures: [],
      disabled: true,
    };
  },
  methods: {
    queryOrderDetail(orderNo) {
      var url = "order/detail/" + orderNo;
      var self = this;
      this.$axios.get(url).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.form = response.data.data;
          //客户编号
          self.$refs.custSelector.customerNo = self.form.customerNo;
          self.$refs.orderItemTable.tableData = response.data.data.orderItems;
          //胚纱类型
          self.$refs.yarnSelector.selectYarnId = response.data.data.yarnType;
          if (self.form.pictures) {
            self.$refs.upload.fileList = JSON.parse(self.form.pictures);
          }
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    recover() {
      const orderNo = this.$route.params.orderNo;
      this.queryOrderDetail(orderNo);
    },
    updateOrder() {
      var self = this;
      this.$confirm("修改后无法自动恢复, 请确定数据是否正确?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.form.orderItems = this.$refs.orderItemTable.tableData;
          this.form.customerNo = this.$refs.custSelector.customerNo;
          this.form.yarnType = this.$refs.yarnSelector.selectYarnId;
          this.form.pictures = JSON.stringify(this.$refs.upload.fileList);
          console.log(JSON.stringify(this.form));
          this.$axios.post("order/update", self.form).then(function (response) {
            if (response.data.errorCode == "00000") {
              self.$message({
                message: "更新成功",
                type: "success",
              });
            } else {
              self.$message.error(response.data.errorMsg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    cancel() {
      //this.$router.back(-1);
      this.disabled = true;
      this.$refs.custSelector.disabled = this.disabled;
      this.$refs.orderItemTable.show = !this.disabled;
      this.$refs.upload.disabled = this.disabled;
      this.$refs.yarnSelector.disable = this.disabled;
    },
    toUpdateOrder() {
      this.disabled = false;
      this.$refs.custSelector.disabled = this.disabled;
      this.$refs.orderItemTable.show = !this.disabled;
      this.$refs.upload.disabled = this.disabled;
      this.$refs.yarnSelector.disable = this.disabled;
    },
    toPlan() {
      this.$router.push("/order/plan/create/" + this.$route.params.orderNo);
    },
  },
  created: function () {
    console.log("OrderUpdate created");
  },
  mounted: function () {
    //订单编号
    const orderNo = this.$route.params.orderNo;
    //订单信息
    this.queryOrderDetail(orderNo);
    list().then((response) => {
      this.supplierList = response.data.data.list;
    });
    this.$refs.custSelector.disabled = this.disabled;
    this.$refs.orderItemTable.show = !this.disabled;
    this.$refs.upload.disabled = this.disabled;
    this.$refs.yarnSelector.disable = this.disabled;
  },
};
</script>

<style scoped>
.el-form {
  --width: 600px;
  margin-top: 50px;
}
.rightBtn {
  float: right;
  margin-top: -25px;
}
</style>